import MineralsGridItem from './MineralsGridItem'
export default function MineralsGrid({ minerals }) {
  return (
    <div className="grid grid-cols-12 gap-2">
      {minerals?.map((mineral) => (
        <MineralsGridItem
          key={mineral.id}
          mineral={mineral}
        />
      ))}
    </div>
  )
}
